import React from "react";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import { connect } from "react-redux";
import TemplateDate from "./TemplateDate";
import TemplateDatetime from "./TemplateDatetime";
import TemplateTime from "./TemplateTime";

const TemplateDatetimeControl = (props ) => {
    if(props.type === "datetime"){
        return (
            <TemplateDatetime questionId={props.questionId} language={props.language}/>
        )
    }else if(props.type === "time"){
        return (
            <TemplateTime questionId={props.questionId} language={props.language}/>
        )
    }
    return (
        <TemplateDate questionId={props.questionId} language={props.language}/>
    )
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        display : state['questionsList'][props.questionId].display,
        required: state['questionsList'][props.questionId].required,
        readonly:  state['questionsList'][props.questionId].readonly,
        appearance: state['questionsList'][props.questionId].appearance,
        ["label::"+props.language] : state['questionsList'][props.questionId]["label::"+props.language],
        ["hint::"+props.language] : state['questionsList'][props.questionId]["hint::"+props.language],
        type:state['questionsList'][props.questionId].type
    };
}
export default connect(mapStateToProps)(TemplateDatetimeControl);

export const plusStyle = () =>{
    return {
        fontSize: "25px",
        fontWeight: 'bold',
        width: '100%',
        border: 'none', 
        borderTopRightRadius: '5px',
        borderTopLeftRadius: '5px',
        backgroundColor: "#eee",
        color: "#737373"
    }
}

export const minusStyle = () =>{
    return {
        fontSize: "25px",
        fontWeight: 'bold',
        width: '100%',
        border: 'none', 
        borderBottomRightRadius: '5px',
        borderBottomLeftRadius: '5px',
        backgroundColor: "#eee",
        color: "#737373"
    }
}
export const setStyle = (appearances) =>{
    let colorCode = appearances.match(/[0-9a-f]{6}/gi);
    colorCode = colorCode !=null ? colorCode : "";
    let color, backgroundColor = ''

    if (colorCode.length === 2) {
        color = colorCode ? `#${colorCode[1]}` : "var(--primary-color)";
        backgroundColor = '#' + colorCode[0];
    } else {
        color = "var(--accent-color)";
        backgroundColor = colorCode ? `#${colorCode}` : "var(--primary-color)";
    }
    let styleDisplay = {
        width: '100%',
        height: '40px',
        textAlign: 'center',
        color: color,
        backgroundColor: backgroundColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',        
        cursor: "pointer"
    }
    return styleDisplay
}

export const displayDateFunc =  (date,flag) => {
    const monthName = [("Jan"), ("Feb"), ("Mar"), ("Apr"), ("May"), ("Jun"),("Jul"), ("Aug"), ("Sep"), ("Oct"), ("Nov"), ("Dec")];
    if(flag ==="date"){
       return date.getDate()
    } else if(flag === "month"){
       return monthName[date.getMonth()]
    } else if (flag === "year"){
       return date.getFullYear()
    } else if (flag === "hours"){
        return date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
    } else if (flag === "minutes"){
        return date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
    }
}